export var continuousDaysTypeOptions = [{
  label: '30天',
  value: 30
}, {
  label: '3天',
  value: 3
}, {
  label: '5天',
  value: 5
}, {
  label: '7天',
  value: 7
}];
export var renewTypeOptions = [{
  label: '激励视频',
  value: 1
}];
export var statusOptions = [{
  label: '上架',
  value: 1
}, {
  label: '下架',
  value: 0
}];
export var defaultFormData = {
  applicationId: '',
  applicationName: '',
  activityImage: '',
  title: '',
  rewardType: 1,
  rewardValue: undefined,
  continuousDays: continuousDaysTypeOptions[0].value,
  renewTimes: 1,
  renewType: 1,
  rewardVideoCount: 1,
  rules: '',
  status: 1,
  sort: 100,
  isDelayTask: 0,
  delayTitle: '',
  delayType: 1,
  // 延时任务类型： 1购买商品
  delayStartDay: 1,
  delayEndDay: continuousDaysTypeOptions[0].value,
  delayRequiredCount: 1,
  delayPagePath: '',
  taskConfigs: []
};
export var taskTypeOptions = [{
  label: '每日打卡',
  value: 1
}, {
  label: '打开小程序',
  value: 2
}, {
  label: '激励视频',
  value: 3
}];
export var taskItem = {
  id: '',
  // 任务id
  activityId: '',
  // 所属打卡活动id
  taskType: 1,
  // 任务类型
  taskTitle: '',
  // 任务标题
  dailyLimit: 1,
  // 任务完成次数
  miniProgramAppId: '',
  // 打开小程序参数
  miniProgramUrl: '',
  // 打开小程序|购买商品 参数
  effectDay: 0,
  taskSort: 0
  // startDay: 1, // 延时任务参数
  // dayLimit: 1, // 延时任务参数
};
export var formRules = {
  applicationId: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择应用'
  }],
  activityImage: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择活动图'
  }],
  title: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入活动名称'
  }],
  rewardValue: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入连签奖励'
  }],
  continuousDays: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择连签天数'
  }],
  renewTimes: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入可续签次数'
  }],
  renewType: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择续签方式'
  }],
  rewardVideoCount: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入激励视频数量'
  }],
  rules: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入活动规则'
  }],
  status: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择状态'
  }],
  sort: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入排序'
  }],
  isDelayTask: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择是否开启延时任务'
  }],
  delayTitle: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入延时任务标题'
  }],
  delayStartDay: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请选择第几天开始延时任务'
  }],
  delayEndDay: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入第几天结束延时任务'
  }],
  delayPagePath: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入延时任务页面路径'
  }],
  delayRequiredCount: [{
    required: true,
    trigger: ['blur', 'change'],
    message: '请输入延时任务完成次数'
  }]
};